import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import axios from 'axios';
var loggerUrl = process.env.GATSBY_BASE_LOGGER_URL;
var DEFAULT_SOURCE_ENDPOINT = "embedded-how-to-pay";
export var Logger = function () {
  var loggerRequest = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, sourceUrl, bodyInformation) {
      var status, _response$config, method, url;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (sourceUrl === void 0) {
                sourceUrl = DEFAULT_SOURCE_ENDPOINT;
              }

              status = response.status;
              _response$config = response.config, method = _response$config.method, url = _response$config.url;
              _context.prev = 3;
              _context.next = 6;
              return axios.post(loggerUrl + "/" + sourceUrl, {
                method: method,
                url: url,
                durationMs: +Date.now() - 0,
                status: status,
                body: {
                  bodyInformation: bodyInformation
                }
              });

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](3);
              console.log("Something went wrong while logging request, " + _context.t0.response.data.error);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 8]]);
    }));

    return function loggerRequest(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    loggerRequest: loggerRequest
  };
}();